import { create } from "zustand";
import agent from "../services/api";
import { CommonResponseModel, threadTickets, ticketFieldData, ticketStatusData } from "../models/axiosModel";
import { ticketFieldSequenceMap } from "../pages/ruleBasedInbox/constants";

interface ticketStoreInterface {
    ticketStatusData: ticketStatusData[] | null,
    setTicketStatusData: (value: ticketStatusData[] | null) => void,

    getTicketStatusListApi: () => Promise<CommonResponseModel<ticketStatusData>>,

    ticketFieldData: ticketFieldData[] | null,
    setTicketFieldData: (value: ticketFieldData[] | null) => void,

    getTicketFieldApi: () => Promise<CommonResponseModel<ticketFieldData>>,

    flagCreateSubStatusPopup: boolean,
    setFlagCreateSubStatusPopup: (value: boolean) => void,

    selectedSubStatus: ticketStatusData | null,
    setSelectedSubStatus: (value: ticketStatusData | null) => void,

    filterStatusesBySubstatusFlag: (flagSubstatus: boolean) => ticketStatusData[],

    selectedTicket: threadTickets | null,
    setSelectedTicket: (value: threadTickets | null) => void,

    flagCreateTicketPopup: boolean,
    setFlagCreateTicketPopup: (value: boolean) => void
}

export const useTicketStore = create<ticketStoreInterface>((set, get) => ({
    ticketStatusData: null,
    setTicketStatusData: (value: ticketStatusData[] | null) => set({ ticketStatusData: value }),

    getTicketStatusListApi: async () => {
        const res = await agent.getTicketStatusList.get();
        if(res.status){
            set({ ticketStatusData: res?.data })
        } else {
            set({ ticketStatusData: null })
        }
        return res;
    },

    ticketFieldData: null,
    setTicketFieldData: (value: ticketFieldData[] | null) => set({ ticketFieldData: value }),

    getTicketFieldApi: async () => {
        const res = await agent.getTicketField.get();
        if(res.status){
            set({ ticketFieldData: res?.data?.map((field: ticketFieldData) => {
                return {
                    ...field,
                    sequence: ticketFieldSequenceMap[field?.thread_ticket_field_name]
                }
            }) })
        } else {
            set({ ticketFieldData: null })
        }
        return res;
    },

    flagCreateSubStatusPopup: false,
    setFlagCreateSubStatusPopup: (value: boolean) => set({ flagCreateSubStatusPopup: value }), 

    selectedSubStatus: null,
    setSelectedSubStatus: (value: ticketStatusData | null) => set({ selectedSubStatus: value }),

    filterStatusesBySubstatusFlag: (flagSubstatus: boolean) => {
        const ticketStatusData = get().ticketStatusData;
        return ticketStatusData?.filter((status) => status?.flag_substatus === flagSubstatus) ?? [];
    },

    selectedTicket: null,
    setSelectedTicket: (value: threadTickets | null) => set({ selectedTicket: value }),

    flagCreateTicketPopup: false,
    setFlagCreateTicketPopup: (value: boolean) => set({ flagCreateTicketPopup: value })
}))